import ChooseYourLookItemInterface from "../../../interfaces/main/ChooseYourLookItemInterface";
import Point from "./Point";
import ChooseYourLookPointInterface from "../../../interfaces/main/ChooseYourLookPointInterface";
import {getBaseImagePath} from "../../catalog/Utils";
import React, {useState, useEffect} from "react";


const compressImage = (src: string, maxWidth: number = 400, quality: number = 0.75): Promise<string> => {
	return new Promise((resolve) => {
		const img = new Image();
		img.crossOrigin = 'anonymous';
		img.onload = () => {
			const canvas = document.createElement('canvas');
			const ctx = canvas.getContext('2d');
			
			const ratio = Math.min(maxWidth / img.width, maxWidth / img.height);
			canvas.width = img.width * ratio;
			canvas.height = img.height * ratio;
			
			ctx?.drawImage(img, 0, 0, canvas.width, canvas.height);
			resolve(canvas.toDataURL('image/jpeg', quality));
		};
		img.onerror = () => resolve(src);
		img.src = src;
	});
};

const Item = ({showIntro, item, changeItem, setSelectedItem}: {
	showIntro?: boolean
	item: ChooseYourLookItemInterface,
	changeItem: (item:ChooseYourLookItemInterface) => void,
	setSelectedItem: (item:ChooseYourLookItemInterface) => void
}) =>
{
	const [compressedImageUrl, setCompressedImageUrl] = useState<string>('');
	const [isMobile, setIsMobile] = useState<boolean>(false);

	useEffect(() => {
		const checkMobile = () => {
			setIsMobile(window.innerWidth <= 991);
		};
		
		checkMobile();
		window.addEventListener('resize', checkMobile);
		return () => window.removeEventListener('resize', checkMobile);
	}, []);

	useEffect(() => {
		if (isMobile) {
			const originalUrl = getBaseImagePath() + item.image;
			compressImage(originalUrl, 400, 0.75).then(setCompressedImageUrl);
		} else {
			setCompressedImageUrl('');
		}
	}, [item.image, isMobile]);

	const changePoint = (point:ChooseYourLookPointInterface) => {
		let points = [...item.points.filter(lpoint => lpoint.uid !== point.uid), ...[point]]
		item.points = points
		changeItem(item)
	}

	const imageUrl = (isMobile && compressedImageUrl) || getBaseImagePath() + item.image;

	return (<>
		{showIntro && <div className="choose__info desk">
			<h2 className="f-exp">Подбери<br className="desk"/> свой образ</h2>
			<p>Выбирай, что нравится только тебе</p>
		</div>}
		{item && <div className="swiper-slide-cont">
			<div className="slide__wrap">
				<picture>
					<source srcSet={imageUrl}
							media="(max-width: 992px)"/>
					<img src={imageUrl} alt=""/>
				</picture>
				<a className="btn btn-primary btn-bd" href="" onClick={(e) => {
					e.preventDefault()
					setSelectedItem(item)
				}}><i
					className="ico ico-color ico-eye-black"></i>
					<span>Весь образ</span></a>
				<p className="choose__slide-name">{item.name}</p>
				{item.points.map((point:ChooseYourLookPointInterface) => <Point key={point.uid} changePoint={changePoint} point={point}  />)}
			</div>
		</div>}
	</>)
}

export default Item